import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getSystemGoStatus } from '../../../api/memberships';

const useSystemGoStatus = (
  systemGid?: string,
  options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>
) => {
  return useQuery({
    queryKey: ['systemGoStatus', systemGid],
    queryFn: () => getSystemGoStatus(systemGid),
    ...options,
  });
};

export default useSystemGoStatus;
